// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.separator_separator__dG_q {
  width: 100%;
  border: none;
  border-top: 2px solid var(--ui-black-transparent);
  margin: 0.5rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-extension-separator/separator.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,gBAAgB;AAClB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.separator {\n  width: 100%;\n  border: none;\n  border-top: 2px solid var(--ui-black-transparent);\n  margin: 0.5rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separator": `separator_separator__dG_q`
};
export default ___CSS_LOADER_EXPORT___;
